export default "__VITE_ASSET__BFDejwtx__"